// extracted by mini-css-extract-plugin
export default {"gallery":"dQX8m","slide":"dTWiG"};